import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const FieldHelpIcon = ({ title }) => (
  <Tooltip title={title} placement="top" arrow>
    <IconButton size="small" sx={{ p: 0.25, ml: 0.5 }} aria-label={title}>
      <HelpOutlineIcon sx={{ fontSize: 18 }} color="action" />
    </IconButton>
  </Tooltip>
);

export default FieldHelpIcon;
